import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the node api
 */
export class NodeService extends BaseService {
	
	constructor() {	
		super();
	}
	
	//DETAILS
	
	async getNodes() {		
		var nodes = await this.makeGETRequest('/api/resource/nodes');		
		return nodes;
	}	
	
	async enableNode(nodeId) {
		var node = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/enable');		
		return node;		
	}
	
	async disableNode(nodeId) {
		var node = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/disable');		
		return node;		
	}
	
	async updateNodeJobs(nodeId, nodeJobs) {
		var node = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId), nodeJobs);		
		return node;		
	}	
	
	async deleteNode(nodeId) {	
		var results = await this.makeDELETERequest('/api/resource/nodes/' + encodeURIComponent(nodeId));
		return results;
	}	

	async getNodeStatus(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/status');		
		return status;
	}

	async getRoutingStats(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/routing-stats');		
		return status;
	}
	
	async getEmailStats(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/emailstats');		
		return status;
	}	
	
	//THREADS
	
	async getThreads(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/threads');		
		return status;
	}	

	async getThreadDetails(nodeId, threadId) {	
		var details = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/threads/' + threadId + '/stack', true);
		return details;
	}

	async threadInterrupt(nodeId, threadId) {	
		var results = await this.makeDELETERequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/threads/' + threadId + '/interrupt');
		return results;
	}
	
	//MANAGERS
	
	async getManagers(nodeId) {	
		var records = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/managers');
		return records;
	}
	
	async managerStart(nodeId, managerClass) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/managers/' + encodeURIComponent(managerClass) + '/start');
		return result;
	}	

	async managerStop(nodeId, managerClass) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/managers/' + encodeURIComponent(managerClass) + '/stop');
		return result;
	}	

	async managerRestart(nodeId, managerClass) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/managers/' + encodeURIComponent(managerClass) + '/restart');
		return result;
	}

	async getManagerStats(nodeId, managerClass) {
		var stats = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/managers/' + encodeURIComponent(managerClass) + '/stats');
		return stats;
	}

	async appRestart(nodeId) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/restart');
		return result;
	}	
	
	//CACHES

	async getCaches(nodeId) {	
		var records = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/caches');
		return records;
	}

	async flushCache(nodeId, cacheName) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/caches/' + encodeURIComponent(cacheName) + '/flush');
		return result;
	}

	async getCacheManagerIdentity(nodeId) {
		var text = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/cache-manager-identity', true);
		return text;
	}

	//LOGS

	async getLoggers(nodeId) {	
		var records = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/loggers');
		return records;
	}

	async updateLogLevel(nodeId, logger, level) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/logger/' + encodeURIComponent(logger) + '/level', level);
		return result;
	}
	
	async getDBStatus(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/dblogger/status');		
		return status;
	}

	async activateDBLogging(nodeId, on) {	
		var result = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/dblogger/' + on);
		return result;
	}

	async getLogFiles(nodeId) {		
		var records = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/logfiles');		
		return records;
	}
	
	downloadLog(nodeId, filename) {			
		this.downloadFile('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/logfiles/'+encodeURIComponent(filename));		
	};

	/**
	 * Packages logs from online nodes in the background; returns JSON acceptance.
	 */
	async submitNodeLogPackage(packageRequest) {
		var result = await this.makePOSTRequest('/api/resource/nodes/log-package', packageRequest || {});
		return result;
	}
	
	//TASKS

	async getTasksStatus(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/tasks/status');		
		return status;
	}

	async cancelTask(nodeId, taskId) {	
		var results = await this.makeDELETERequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/tasks/' + taskId + '/cancel');
		return results;
	}
	
	//JOBS
	
	async getSchedulerStatus(nodeId) {		
		var status = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/status');		
		return status;
	}
	
	async getSchedulerPause(nodeId) {		
		var status = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/scheduler/pause');		
		return status;
	}
	
	async getSchedulerResume(nodeId) {		
		var status = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/scheduler/resume');		
		return status;
	}	
	
	async getJobs(nodeId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var jobs = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs' + params);		
		return jobs;
	}	
	
	async getAssignedJobsStats(nodeId) {		
		var data = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/assigned-job-stats');		
		return data;
	}	
	
	async getJobPause(nodeId, groupname, jobname) {		
		var job = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/pause');		
		return job;
	}	
	
	async getJobResume(nodeId, groupname, jobname) {		
		var job = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/resume');		
		return job;
	}
	
	async getJobRunNow(nodeId, groupname, jobname, parameters) {		
		var job = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/runnow', parameters);		
		return job;
	}
	
	async deleteJob(nodeId, groupname, jobname) {		
		var result = await this.makeDELETERequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname));		
		return result;
	}
	
	async saveJob(nodeId, job, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/' + encodeURIComponent(job.group) + '/' + encodeURIComponent(job.name), job);
		} else {
			saved = await this.makePOSTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs', job);
		}
		return saved;
	}

	exportJobs(nodeId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/jobs/export' + params);
	}

	//IO Stats
	async getIOStats(nodeId) {
		var data = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/io-stats');
		return data;
	}	

	//properties
	async getProperties(nodeId) {		
		var jobs = await this.makeGETRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/properties');		
		return jobs;
	}	
	
	async saveProperty(nodeId, property) {
		var saved = await this.makePUTRequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/properties', property);		
		return saved;
	}	
	
	async deleteProperty(nodeId, key) {		
		var result = await this.makeDELETERequest('/api/resource/nodes/' + encodeURIComponent(nodeId) + '/properties/' +  encodeURIComponent(key));		
		return result;
	}	
	

};
